import UserInfoView from './views/UserInfoView';

export default UserInfoView;